module.exports = "<span class=\"injury-name\">\n    {{ injury.name }}\n</span>"